import {
  ResourceEmptyState,
  SectionWithHeader,
  TextButtonLink,
} from '@maia/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { TaskList } from '../../shared/task/list';
import { getTasksOptions } from './queryOptions';

export function TasksList() {
  const { guid } = useParams({
    from: '/_authenticated/claims/$guid',
  });

  const { data } = useSuspenseQuery(getTasksOptions(guid));

  return (
    <SectionWithHeader
      title="Openstaande taken"
      resource="openstaande taken"
      action={
        <TextButtonLink
          size="tiny"
          to={`/claims/$guid/tasks`}
          params={{ guid }}
        >
          Bekijk alles
        </TextButtonLink>
      }
    >
      {data.response.length === 0 ? (
        <ResourceEmptyState message={'Er zijn geen openstaande taken'} />
      ) : (
        <TaskList tasks={data.response} />
      )}
    </SectionWithHeader>
  );
}
